var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AlertAFY, ButtonAFY, FormsPlansAFY, IconAFY, icons, severity, sizes, sizesIcon, variants, variantsAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { Title } from "../../../components/layout/style";
import { themeCore } from "../../../assets/themes/theme";
import { ModalBenefit, ModalConfirmDelete, ModalPrime } from "../component";
import { BACK_LABEL, FORMS_PLANS_TEXTS, PAGE_TITLE, } from "../constants/planCreation.constants";
import { AlertWrapper, Container, ContainerAlert, ContainerIcon, ContainerTitle, } from "../style/planCreation.style";
var BACK_BUTTON_PROPS = {
    variant: variants.text,
    icon: icons.ArrowBackIosNew,
    size: sizes.small,
    color: themeCore.colors.primaryText,
};
var ALERT_PROPS = {
    title: "",
    description: "",
    iconClose: icons.Close,
    iconCloseColor: "#fff",
    severity: severity.info,
    variant: variantsAlert.filled,
    backgroundColor: "#637985",
    iconColor: "#FFF",
    spacing: 0,
    textColor: "#fff",
    width: "100%",
};
var FORMS_PLANS_PROPS = {
    formsCompleted: [true],
    showButtonsActions: true,
    seeButtonAddPlans: false,
    showButtonAddBenefits: true,
    showButtonAddPrimes: true,
    textLegendColor: "#bcbcbc",
    paymentModeOption: [],
};
var saveTab = function (_event, tab) {
    localStorage.setItem("tab", tab.toString());
};
export var PlanCreationView = function (props) {
    var selectedItems = props.selectedCoverTypes.length
        ? props.selectedCoverTypes.map(function (item) { var _a; return (_a = item.name) !== null && _a !== void 0 ? _a : ""; }).join(", ")
        : undefined;
    return (_jsxs(_Fragment, { children: [_jsx(ModalBenefit, { openModal: props.openModalBenefit, onClose: props.onCloseModalBenefit, dataFormBenefits: props.dataFormBenefits, onSave: props.onSaveBenefit }), _jsx(ModalPrime, { openModal: props.openModalPrime, onClose: props.onClosePrimeModal, paymentModeList: props.paymentModeList, coverTypeList: props.selectedCoverTypes, dataFormPrimes: props.dataFormPrimes, onSave: props.onSavePrime }), _jsx(ModalConfirmDelete, { openModal: props.openModalConfirmDelete, setOpenModal: props.setOpenModalConfirmDelete, title: props.titleDelete, onConfirmDelete: props.onConfirmDelete }), _jsxs(ContainerAlert, { children: [_jsx(Container, { children: _jsx(ButtonAFY, __assign({}, BACK_BUTTON_PROPS, { label: BACK_LABEL, onClick: props.onClickBack })) }), _jsx(AlertWrapper, { children: _jsx(AlertAFY, __assign({}, ALERT_PROPS, { isOpen: props.showAlert, setAutoClose: props.autoCloseActive, autoClose: props.autoClose, onClose: function () { return props.setShowAlert(false); } })) })] }), _jsxs(ContainerTitle, { children: [_jsx(Title, { children: PAGE_TITLE }), props.idPlan && props.isEdit !== "true" && (_jsx(ContainerIcon, { children: _jsx(IconAFY, { icon: icons.Visibility, size: sizesIcon.medium, color: "#3A56A1" }) }))] }), _jsx(FormsPlansAFY, __assign({}, FORMS_PLANS_PROPS, FORMS_PLANS_TEXTS, { handleChangeTab: saveTab, permissions: props.permissions, coverageTypes: props.coverageTypeList, typeList: props.coverageTypeList, onChangeSelect: props.onUpdateCoverTypeSelected, onNext: props.handleSubmitPlan, onSendPlanForm: props.handleSubmitPlan, onSendPrimes: props.handleSubmitPlan, onSendBenefits: props.handleSubmitPlan, onClickAddBenefits: props.onClickAddBenefits, onClickAddPrimes: props.onClickAddPrimes, panelActive: props.currentTab, disableBenefits: props.disableBenefits, disablePrimes: props.disablePrimes, activateEditMode: props.activateEditMode, showCancelButton: props.activateEditMode, selectedItems: selectedItems, columnsBenefits: props.columnsBenefits, rowsBenefits: props.benefitsData, columnsPrimes: props.columnsPrimes, rowsPrimes: props.scenarios, dataPlanCreationForm: props.planData }))] }));
};
